import { RootState } from '../Store';

export const keyboardSelector = (state: RootState) => state.keyboard;
